module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/func_scout-4843dfa556556886369d3f830b444576.png";